import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  ViewEncapsulation,
  Input,
  OnInit,
  OnDestroy,
} from '@angular/core'
import { MatPaginator, PageEvent } from '@angular/material/paginator'
import { AuctionFacade } from 'libs/gb-front/auction/data-access/src/'
import { VolunteerProfileEntity } from 'libs/gb-front/profile/data-access/src'
import { ProfilesFacade } from 'libs/gb-front/profile/data-access/src/lib/+state/profiles.facade'
import * as ProfileActions from 'libs/gb-front/profile/data-access/src/lib/+state/profiles.actions'
import * as SelectedProfileActions from 'libs/gb-front/selected-profile/data-access/src/lib/+state/selected-profile.actions'
import { LoaderActionTypeEnum, LoaderFacade } from 'libs/shared/utils/loader/src'
import { BehaviorSubject, debounceTime, distinctUntilChanged, skip } from 'rxjs'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
  selector: 'gb-select-guest-dialog',
  templateUrl: './gb-select-guest-dialog.component.html',
  styleUrls: ['./gb-select-guest-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbSelectGuestDialogComponent implements OnInit, OnDestroy {
  @Input() showConfirmation = true
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator

  auctionStatus$ = this.auctionFacade.auctionStatus$
  allProfiles$ = this.profilesFacade.allProfiles$
  profilesCount$ = this.profilesFacade.profilesCount$
  isLoading$ = this.loaderFacade.getIsLoading$(LoaderActionTypeEnum.LoadProfiles)

  searchTerm = ''
  // Paginator config
  pageSize = 10
  pageSizeOptions: number[] = [10, 25, 100]

  private searchTermSubject$ = new BehaviorSubject<string>(this.searchTerm)

  constructor(
    private profilesFacade: ProfilesFacade,
    private auctionFacade: AuctionFacade,
    private loaderFacade: LoaderFacade,
  ) {}

  ngOnInit(): void {
    this.getProfiles()

    this.searchTermSubject$
      .pipe(debounceTime(500), skip(1), distinctUntilChanged(), untilDestroyed(this))
      .subscribe(() => {
        this.paginator.firstPage()
        this.getProfiles()
      })
  }

  ngOnDestroy(): void {
    // reset state to first page of profiles
    this.profilesFacade.dispatch(ProfileActions.loadProfilesVolunteer())
  }

  getProfiles(event?: PageEvent): void {
    let offset = 0
    if (event) {
      this.pageSize = event.pageSize
      offset = event.pageIndex * 10
    }

    this.profilesFacade.dispatch(ProfileActions.loadProfilesVolunteer(this.pageSize, offset, this.searchTerm))
  }

  onSearchChange(): void {
    this.searchTermSubject$.next(this.searchTerm)
  }

  onGuestSelect(profile: VolunteerProfileEntity): void {
    this.profilesFacade.dispatch(SelectedProfileActions.setSelectedProfile({ uuid: profile.uuid }))
  }
}
